module.exports = __webpack_public_path__ + "static/media/icon_notif.0dbdedeb.png";